define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action",
	"csi/table/Delete",
	"csi/xml"
], function(declare,_,csiAction,Delete,xml) {

	return declare(Delete, {

		parent: null,

		preProcess: function() {
			var version = this.getNode();

			if (version) {
				this.parent = this.m_cache.addNode(xml.getUrlPath(version.$URL, "Child:__Parent__"));
			}

			this.inherited(arguments);
		},

		getString: function(/*String*/suffix, /*String[]?*/params) {
			// DE22954: If a MerchProductVersion or MerchOptionVersion is a previous carryover then prompt user
			// before deleting the version.

			if (this.parent && this.getNode()) {

				if (suffix == csiAction.SUFFIX_CONFIRM) {
					params = [this.parent.$Name, params[0]];
					suffix += "_InVersion";
				}

				// Find any carryover MerchVersions that have this node as its Previous reference
				var bCarryover = _.find(this.parent.Versions, function(cnl) {
					var version = this.m_cache.getNode(cnl, true);
					return version.Legacy == "MerchLegacy:Carryover" && version.Previous == this.getNodeURL();
				}, this);

				if (bCarryover && suffix == csiAction.SUFFIX_CONFIRM) {
					suffix += "_Carryover";
				}
			}
			return this.inherited(arguments, [suffix, params]);
		}

	});
});